import React from 'react';
import {Announcements} from 'api';
import {LoadingPage} from 'components/loading-page';
import {DateTime} from 'components/UI/DateTime';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';

class MyBusinessAnnouncementDetailContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: null,
      isLoading: false
    };
  }

  componentDidMount() {
    if (this.props.params && this.props.params.id) {
      this.getAnnouncement(this.props.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.getAnnouncement(nextProps.params.id);
    }
  }

  getAnnouncement(id) {
    this.setState({isLoading: true});
    Announcements.actions.announcement.request({id}).then(response => {
      this.setState({data: response.data, isLoading: false});
    }).catch((error) => {
      this.setState({isLoading: false});
      this.props.history.push('/my-business/announcements');
      toastr.error('Lỗi!', 'Không tìm thấy thông báo này');
    });
  }

  render() {
    if (!this.state.data) {
      return null;
    }
    return (
      <section className='announcement-container mb35'>
        <div className="announcement-detail">
          <LoadingPage isShow={this.state.isLoading} />
          <h2 className="title">{this.state.data.title}</h2>
          <div className="time"><DateTime dateTime={this.state.data.createdAt}/></div>
          <div className="content" dangerouslySetInnerHTML={{__html: this.state.data.content}}></div>
        </div>
      </section>
    );
  }
}

export default withRouter(MyBusinessAnnouncementDetailContent);



// WEBPACK FOOTER //
// ./components/my-business/sub-view/announcement/MyBusinessAnnouncementDetailContent.jsx